import InvoiceAddContent from "../content/invoiceAddContent";
import Layout from "../layout/Layout";

function InvoiceAdd() {
  return (
    <Layout>
      <InvoiceAddContent />
    </Layout>
  );
}

export default InvoiceAdd;
